<app-dialog-simple
  [textContent]="{
    title: 'pop-up.annuler-modif.texte-premiere-ligne',
    titleId: 'titre-modale',
    paragraph: 'pop-up.annuler-modif.texte-deuxieme-ligne',
    paragraphId: 'texte-modale',
    confirmButton: 'btn.oui',
    cancelButton: 'btn.non'
  }"
  (close)="close()"
  (confirm)="confirm()"
>
</app-dialog-simple>
